import {
  createSlice,
  createAsyncThunk,
  // PayloadAction,
  // ActionReducerMapBuilder,
} from "@reduxjs/toolkit";
import { config } from "../../../utils/config";
// import { tokenDecode } from "../../../utils/helper";
import axios from "axios";

// const decoded = tokenDecode();
// const { data } = decoded;
// const seller_id = data?.user?.seller_id;
const { apiEndpoint } = config;
// const accessToken = localStorage.getItem("us_st_d");
interface VendorState {
  loader: boolean;
  vendorData: any;
  error: string | null;
}

const initialState: VendorState = {
  loader: false,
  vendorData: null,
  error: null,
};

// Create the async thunk for fetching vendor data
export const fetchVendorData = createAsyncThunk(
  "vendor/fetchVendorData",
  async (seller_id: string, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${apiEndpoint}/seller/getVendor/${seller_id}`,
      );
      if (response.status === 200) {
        return response.data?.data;
      } else {
        return rejectWithValue("Failed to fetch vendor data");
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  },
);

// Create the slice
const vendorSlice = createSlice({
  name: "vendor",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchVendorData.pending, (state) => {
      state.loader = true;
      state.error = null;
      state.vendorData = null;
    });
    builder.addCase(fetchVendorData.fulfilled, (state, action) => {
      state.loader = false;
      state.vendorData = action.payload;
      state.error = null;
    });
    builder.addCase(fetchVendorData.rejected, (state, action) => {
      state.loader = false;
      state.vendorData = null;
      state.error = action.payload as string;
    });
  },
});

export default vendorSlice.reducer;
